import { graphql } from "api/cms-website/generated";

export const MapFragment = graphql(/* GraphQL */ `
    fragment MapFragment on ComponentComponentsMap {
        id
        title
        noMarginBottom
    }
`);
